import React from "react";
import Date from "./Date";

const BreakdownDate = ({ value, format }) => {
  return <Date value={value} format={format} down />;
};

export default BreakdownDate;
